import React from 'react';
import BaseChart from './BaseChart';
import { ChartType } from './BaseChart';

export interface ProductDistributionChartProps {
  data: {
    labels: string[];
    values: number[];
  };
  title: string;
  options?: any;
  type?: ChartType;
}

const ProductDistributionChart: React.FC<ProductDistributionChartProps> = ({ 
  data, 
  title, 
  options = {}, 
  type = 'pie' 
}) => {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: title,
        data: data.values,
        backgroundColor: [
          'rgba(255, 99, 132, 0.5)',
          'rgba(54, 162, 235, 0.5)',
          'rgba(255, 206, 86, 0.5)',
          'rgba(75, 192, 192, 0.5)',
          'rgba(153, 102, 255, 0.5)',
        ],
        borderColor: [
          'rgb(255, 99, 132)',
          'rgb(54, 162, 235)',
          'rgb(255, 206, 86)',
          'rgb(75, 192, 192)',
          'rgb(153, 102, 255)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const defaultOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: title,
      },
    },
    ...options,
  };

  return (
    <BaseChart
      type={type}
      data={chartData}
      title={title}
      height={300}
      width={800}
      options={defaultOptions}
    />
  );
};

export default ProductDistributionChart; 